module.exports = __webpack_public_path__ + "img/logo-opo-creations.a43c9d2e.svg";